import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loadable from "../../../components/loadable/Loadable";
import { componentKey, resetUserInteractionPopupWResponseObj, setErrorInFormFieldsOrFormData, setGoToManageBoiScreen, setHelpTextObj, setIsAddNewBenefiarySelected, setLoadDependentFieldsArr, setOnDependentFields, setReportingCompanyScreenNxtBtnClicked, setSelectedBeneficialDetailIds, setShowHelpPopup, setStepperRefreshStep, updateBoiFormFields } from "./FileBoiSlice";
import useGarbageCollector from "../../../../libs/garbagecollector/garbageCollectorHooks";
import SelectedReportingCompany from "./components/SelectedReportingCompany";
import { getBoiFormFields, getFormData, getReviewData, saveBoiForm, saveCompanyApplicants, saveReportingCompany } from "./FileBoiSaga";
import FilingInformation from "./components/FilingInformation";
import StepperNavigation from "../../../components/steppernavigation/StepperNavigation";
import CompanyApplications from "./components/CompanyApplications";
import Review from "./components/Review";
import Submit from "./components/submit/Submit";
import ReportingCompanies from "./components/ReportingCompanies";
import { BOI_FORM_STEPS, BOI_REPORTING_SECTION_ROUTES, FILE_BOI_LOADING_STATES, FILE_BOI_LOADING_STATES_MESSAGE_MAP, PRE_FILLED_FIELDS_MAP } from "../constants";
import FormEventHandlers from "../../../../libs/utility/formeventhandlers/FormEventHandlers";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import useTxSearchParams from "../../../../libs/txsearchparams/TxSearchParamsHook";
import useTxNavigate from "../../../../libs/txnavigate/TxNavigateHook";
import BeneficialOwnersList from "./components/beneficialownerslist/BeneficialOwnersList";
import { componentKey as authenticationComponentKey } from "../../authentication/AuthenticationSlice";
import { MANAGE_BOI_ROUTES } from "../../constants/constants";
import RenderInteractionElement from "../../../components/renderinteractionelementforformslibrary/RenderInteractionElement";
import { TOASTER_VARIANT } from "../../../components/toast/constants";
import Popup from "../../../components/popup/Popup";
import styles from  './FileBoi.Styles';

export default function FileBoi(){

    useGarbageCollector(componentKey);
    const { loadingState, stepperRefreshStep, reportingCompanyScreenNxtBtnClicked, boiFormFields, gridSelectedPayers, formRecordId, errorInFormFieldsOrFormData, gridSelectedRecipients, isAddNewBenefiarySelected, reportingCompanyDetailId, loadDependentFieldsArr, goToManageBoiScreen, userInteractionPopupWResponseObj, selectedBeneficialDetailIds, isBeneficialSelectAllSelected, showHelpPopup, helpTextObj } = useSelector(state => state[componentKey]);

    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])

    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const navigate = useTxNavigate();

    useEffect(() => {
        const urlFormRecordId = queryParams.get('FormRecordId');
        dispatch(getFormData({formName: BOI_FORM_STEPS.REPORTING_COMPANY, formYear: 2023, formRecordId: urlFormRecordId ?? 0}))
    }, [])

    useEffect(() => {
        if(errorInFormFieldsOrFormData){
            navigate(`/boireporting`);
            dispatch(setErrorInFormFieldsOrFormData(false));
        }
    }, [errorInFormFieldsOrFormData])

    useEffect(() => {
            if(loadDependentFieldsArr){
                let fieldsList =  [];
                for (const step in boiFormFields) {
                    if (boiFormFields.hasOwnProperty(step)) {
                        fieldsList = fieldsList.concat(boiFormFields[step]);
                    }
                }
                FormEventHandlers.updateDependentFieldsArr(fieldsList ?? [], (reverseDependencyMap) => dispatch(setOnDependentFields(reverseDependencyMap)));
                setLoadDependentFieldsArr(false)
            }
    }, [loadDependentFieldsArr]);

    useEffect(() => {
        if(goToManageBoiScreen){
            navigate(MANAGE_BOI_ROUTES.BOI_REPORTING);
            dispatch(setGoToManageBoiScreen(false));
        }
    }, [goToManageBoiScreen])

    useEffect(() => {
        if(reportingCompanyScreenNxtBtnClicked || isAddNewBenefiarySelected){
            let updatedFieldsWPreFilledSubmitStepData = [];
            updatedFieldsWPreFilledSubmitStepData = boiFormFields[BOI_FORM_STEPS.SUBMIT].map(item => {                    
                if(PRE_FILLED_FIELDS_MAP.submit[item?.Name] && !item.hasOwnProperty('inputValue')){
                    return {
                        ...item,
                        inputValue: signedInUser[PRE_FILLED_FIELDS_MAP.submit[item?.Name]],
                    }
                }else{
                    return item
                }
            })
            
            dispatch(updateBoiFormFields({
                [BOI_FORM_STEPS.SUBMIT]: updatedFieldsWPreFilledSubmitStepData,
            }))
        }
    }, [isAddNewBenefiarySelected, reportingCompanyScreenNxtBtnClicked])

    const handleGoToSelectPayerScreen = () => {
        dispatch(setStepperRefreshStep(0));
        dispatch(setReportingCompanyScreenNxtBtnClicked(false));
        dispatch(setIsAddNewBenefiarySelected(false));
    }

    const handleStepSaveAction = (currentStep, nextRefreshStepIndex) => {
        let fieldsList = [];
        if(currentStep !== BOI_FORM_STEPS.SUBMIT){
            fieldsList = boiFormFields[currentStep];
        }else{
            for (const step in boiFormFields) {
                if (boiFormFields.hasOwnProperty(step)) {
                    fieldsList = fieldsList.concat(boiFormFields[step]);
                }
            }
        }
        let validationResult = true;
        validationResult = FormEventHandlers.handleNextBtnClick(currentStep, boiFormFields[currentStep], false, (updatedFieldsList) => dispatch(updateBoiFormFields({[currentStep]: updatedFieldsList})), () => dispatch(addNotifications({ heading: "There are some errors in fields.", message: "To continue, please resolve the highlighted errors" })), true);
        if (validationResult) {
            let finalFormObject = fieldsList.reduce((obj, item) => {
                obj[item.Name] = item.inputValue || null;
                return obj;
            }, {});

            finalFormObject = {
                ...finalFormObject,
                PayerDetailId: reportingCompanyDetailId,
                FormRecordId: formRecordId,
                FormName: currentStep,
            }

            if(currentStep === BOI_FORM_STEPS.REPORTING_COMPANY){
                dispatch(saveReportingCompany({
                    formData: { ...finalFormObject },
                    currentStep: currentStep,
                    nextRefreshStepIndex: nextRefreshStepIndex
                }));
                
            }else if(currentStep === BOI_FORM_STEPS.COMPANY_APPLICATION){
                dispatch(saveCompanyApplicants({
                    formData: { ...finalFormObject },
                    nextRefreshStepIndex: nextRefreshStepIndex,
                    boiFormFields: boiFormFields,
                }))
            }else{
                dispatch(saveBoiForm({
                    formData: { ...finalFormObject, 
                        BeneficialOwnerDetailId: selectedBeneficialDetailIds
                    },
                    currentStep: currentStep,
                    nextRefreshStepIndex: nextRefreshStepIndex,
                    isBeneficialSelectAllSelected: isBeneficialSelectAllSelected,
                }));
            }
            
        }
        return false
    }

    const handleNxtFrmBeneficialSelectionScreen = () => {
        const selectedBeneficialIds = gridSelectedRecipients.map(obj => obj?.BeneficialOwnerDetailId).join(',');
        dispatch(setSelectedBeneficialDetailIds(selectedBeneficialIds))
        dispatch(getReviewData({FormRecordId: formRecordId, BeneficialOwnerDetailId: selectedBeneficialIds, isBeneficialSelectAllSelected: isBeneficialSelectAllSelected}))
        dispatch(setStepperRefreshStep(4))
    }

    const boiReportingSteps = [
        {
            title: `Reporting Company`,
            stepBodyComponent: <SelectedReportingCompany />,
            backButtonText: "Back",
            prevCb: () => { handleGoToSelectPayerScreen() },
            submitButtonText: "Next",
            submitCb: () => handleStepSaveAction(BOI_FORM_STEPS.REPORTING_COMPANY, 1),
        },{
            title: `Filing Information`,
            stepBodyComponent: <FilingInformation />,
            backButtonText: "Back",
            prevCb: () => { dispatch(setStepperRefreshStep(0)) },
            submitButtonText: "Next",
            submitCb: () => handleStepSaveAction(BOI_FORM_STEPS.FILING_INFO, 2),
        },{
            title: `Company Applicant(s)`,
            stepBodyComponent: <CompanyApplications />,
            backButtonText: "Back",
            prevCb: () => { dispatch(setStepperRefreshStep(1)) },
            submitButtonText: "Next",
            submitCb: () => handleStepSaveAction(BOI_FORM_STEPS.COMPANY_APPLICATION, 3),
        },{
            title: `Beneficial Owner(s)`,
            stepBodyComponent: <BeneficialOwnersList />,
            backButtonText: "Back",
            prevCb: () => { dispatch(setStepperRefreshStep(2)) },
            submitButtonText: "Next",
            submitButtonDisabled: (gridSelectedRecipients.length > 0) ? false : true,
            submitButtonDisabledInfoCb: () => {dispatch(addNotifications({ heading: "Warning", message: "Please select beneficial owners", variant: TOASTER_VARIANT.WARNING }))},
            submitCb: () => handleNxtFrmBeneficialSelectionScreen(),
        },{
            title: `Review`,
            stepBodyComponent: <Review />,
            backButtonText: "Back",
            prevCb: () => { dispatch(setStepperRefreshStep(3)) },
            submitButtonText: "Next",
            submitButtonDisabled: true ? false : true,
            submitButtonDisabledInfoCb: () => {},
            submitCb: () => dispatch(setStepperRefreshStep(5)),
        },{
            title: `Submit`,
            stepBodyComponent: <Submit />,
            backButtonText: "Back",
            prevCb: () => { dispatch(setStepperRefreshStep(4)) },
            submitButtonText: "Submit",
            submitCb: () => handleStepSaveAction(BOI_FORM_STEPS.SUBMIT, 0),
        }
    ];
    return <>
        <Loadable currentState={loadingState.state} loadingStates={[FILE_BOI_LOADING_STATES.FILE_BOI_MAIN_LOADING]} messageMap={FILE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} preserveChildMount={true}>
            <Loadable currentState={loadingState.state} loadingStates={[FILE_BOI_LOADING_STATES.CALCULATE_INFERRED_LOADING, FILE_BOI_LOADING_STATES.SAVE_STEP_LOADING]} messageMap={FILE_BOI_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} preserveChildMount={true}>
            {
                    (isAddNewBenefiarySelected || reportingCompanyScreenNxtBtnClicked) ? <StepperNavigation steps={boiReportingSteps} refreshStep={stepperRefreshStep} /> : <ReportingCompanies />
            }
            </Loadable>
        </Loadable>
        {
            (userInteractionPopupWResponseObj?.type) ? <RenderInteractionElement interactionObj={userInteractionPopupWResponseObj}  userInteractionPopupWResponseObj={userInteractionPopupWResponseObj} updateFormFieldsCb={(updatedFieldsList) => dispatch(updateBoiFormFields({
                [userInteractionPopupWResponseObj?.formType]: updatedFieldsList,
            }))} resetUserInteractionPopupWResponseObjCb={() => dispatch(resetUserInteractionPopupWResponseObj())} setInitialInteractionPopupWObjCb={() => {}}  /> : ""
        }
        {
            <Popup title={"Help"} onCloseCb={() => {dispatch(setShowHelpPopup(false)); dispatch(setHelpTextObj({}))}} showClose={true} isPopupOpen={showHelpPopup} customPopupSyles={styles.helpTextPopupStypes} customPopupHeaderStyles={styles.helpTextPopupHeaderStyles} childrenStyles={styles.helpTextChildrenStyles}>
                {
                    helpTextObj?.Value ? <iframe
                        key={helpTextObj?.Target ?? helpTextObj?.Value}
                        src={`${helpTextObj?.Value}${helpTextObj?.Target ?? ''}`}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        allowFullScreen
                    />
                    : 
                    <div>Facing some error. Please try again.</div>
                }
                
            </Popup>
        }
    </>
}